import { Waitlist } from '@clerk/clerk-react';
import { Link } from '@tanstack/react-router';
import { SignedOutLayout } from './SignedOutLayout';

/** /waitlist: Clerk's waitlist form in the signed-out frame. The beta is
 * invite-only, so this is where a visitor without an invitation leaves an
 * address; approving the entry in Clerk sends the invite. The marketing site
 * writes to the same list. */
export function WaitlistPage() {
  return (
    <SignedOutLayout>
      <Waitlist
        signInUrl="/sign-in"
        // The sign-in card drops its subtitle; this one keeps it, since it is
        // the line that says what happens after joining.
        appearance={{ elements: { headerSubtitle: '!block mt-2 text-[15px] leading-[1.5] text-mute' } }}
      />
      <p className="mt-6 text-center text-[13px] text-mute">
        Already invited?{' '}
        <Link to="/sign-in/$" params={{ _splat: '' }} className="font-semibold text-ink hover:text-acc">
          Sign in
        </Link>
      </p>
    </SignedOutLayout>
  );
}
